import { render } from "./TxAudienceTab.vue?vue&type=template&id=32cff1b9&scoped=true"
import script from "./TxAudienceTab.vue?vue&type=script&lang=js"
export * from "./TxAudienceTab.vue?vue&type=script&lang=js"

import "./TxAudienceTab.vue?vue&type=style&index=0&id=32cff1b9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cff1b9"]])

export default __exports__